import React,{useState} from "react";
import './Contactus.css';
import {FaFacebook,FaTelegram,FaTiktok}from 'react-icons/fa'
import api, { API_ENDPOINTS } from "../config";
function Contactus() {

  const [loading, setLoading] = useState(false);
  const [popup, setPopup] = useState({ show: false, success: false, message: "" });


    const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setPopup({ show: false, success: false, message: "" });


    const formData = {
      name: e.target.name.value,
      email: e.target.email.value,
      message: e.target.message.value,
    };

    try {
      const response = await api.post(API_ENDPOINTS.SEND_CONTACTUS_EMAIL, formData);

      if (response.data.status === "success") {
         
         setPopup({ show: true, success: true, message: "Message sent successfully!" });
        e.target.reset();
      } else {
        setPopup({ show: true, success: false, message: "Failed to send message. Try again." });
      }
    } catch (error) {
      console.error("Error:", error);
      setPopup({ show: true, success: false, message: "Something went wrong!" });
    } finally {
      setLoading(false);
    }
  };
  

    return (
        <section className="contact-us">
            <div className="Page-name">
                <h2>Contact us </h2>

            </div>
        <div className="contact-container">
            
          <div className="contact-form">
            <h2>Get in touch</h2>
            <form onSubmit={handleSubmit}>
              <label>Name</label>
              <input type="text" name="name" className="inp-txt" placeholder="Name" required />

              <label>Email</label>
              <input type="email" name="email" className="inp-txt" placeholder="Email" required />

              <label>Message</label>
              <textarea name="message" placeholder="Message" required></textarea>

              <button type="submit" disabled={loading}> { loading ? <span className="spinner"></span> : "SEND"}</button>
            </form>
          </div>
          <div className="contact-info">
            <h2>Reach us</h2>
            <p>📞 +251904803380</p>
            <p>📞 +251902340084</p>
            
            
            <p>📧 info@IklimDigitals.com</p>
            <p>📍 Mebrat-Hail Minch Center, Adama </p>
            <h3>Follow Us:</h3>
            <div className="social-icons">
  <span>
    <a
      href="https://facebook.com/iklimdigitals"
      target="_blank"
      rel="noopener noreferrer"
    >
      <FaFacebook />
    </a>
  </span>

  <span>
    <a
      href="https://tiktok.com/@iklimdigitals"
      target="_blank"
      rel="noopener noreferrer"
    >
      <FaTiktok />
    </a>
  </span>

  <span>
    <a
      href="https://t.me/iklimdigitals"
      target="_blank"
      rel="noopener noreferrer"
    >
      <FaTelegram />
    </a>
  </span>
</div>

          </div>
        </div>


          {/* Popup Message */}
      {popup.show && (
  <div className="popup-overlay">
    <div className={`popup-content ${popup.success ? "success" : "error"}`}>
      <p>{popup.message}</p>
      <button onClick={() => setPopup({ show: false })}>Close</button>
    </div>
  </div>
)}
      </section>
      
    );
  }
  
  export default Contactus;
  